export default "__VITE_ASSET__Dk4XZCBP__"